<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Month And Day Wise Tracker") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="selectedType.id && typeArr.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} Type</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="typeArr"
                v-model="selectedType"
                :searchable="true"
                label="name"
                track-by="id"
                placeholder="Select Type"
                @input="emptyData()"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <template v-if="selectedType.id == 'daywise'">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>
          </template>

          <template v-if="selectedType.id == 'monthwise'">
            <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedMonth && monthArr.length > 0 ? 'shift-up' : ''
                  "
                  >{{ $t("select") }} Month</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="monthArr"
                  v-model="selectedMonth"
                  :searchable="true"
                  label="name"
                  track-by="id"
                  placeholder="Select Month"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedYear && yearArr.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} Year</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="yearArr"
                  v-model="selectedYear"
                  :searchable="true"
                  label="name"
                  track-by="id"
                  placeholder="Select Year"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
          </template>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBudgetReport()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="Records.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getBudgetReport('Y')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table
          class="swc-report-table"
          border="1"
          v-if="selectedType.id == 'daywise'"
        >
          <thead class="bg-lightblue font-weight-bold">
            <tr class="bg-lightgrey">
              <td>Date</td>
              <td colspan="7">
                {{ moment(fromDate).format("Do MMM YYYY") }} -
                {{ moment(toDate).format("Do MMM YYYY") }}
              </td>
            </tr>
            <tr class="blueBg">
              <td>Location</td>
              <td>Admission</td>
              <td>Con Rev</td>
              <td>BO Rev</td>
              <!-- <td>Othr Rev</td> -->
              <td>Total Rev</td>
              <td>SPH</td>
              <td>ATP</td>
              <td>Strike Rate</td>
            </tr>
          </thead>
          <tbody v-if="Records.length == 0">
            <tr>
              <td colspan="6">
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-if="Records.length">
            <tr
              v-for="(dayWiseObj, dayWiseIndex) in Records"
              :key="dayWiseIndex"
            >
              <td class="blueBg text-left">{{ dayWiseObj.cinema_name }}</td>
              <td class="text-right">{{ dayWiseObj.admissions }}</td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.concessions_received) }}
              </td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.boxOffice_received) }}
              </td>

              <!-- <td class="text-right">
                {{
                  dayWiseObj.other_received ? dayWiseObj.other_received : "-"
                }}
              </td> -->
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.total_revenue) }}
              </td>
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.sph) }}
              </td>
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.atp) }}
              </td>
              <td class="blueBg text-right">
                {{
                  currFormat(
                    (dayWiseObj.concessions_received /
                      dayWiseObj.boxOffice_received) *
                      100
                  ) || 0
                }}%
              </td>
            </tr>
            <tr class="blueBg font-weight-bold">
              <td class="text-left">Total</td>
              <td class="text-right">
                {{
                  Records.reduce((acc, { admissions }) => {
                    return acc + +parseFloat(admissions);
                  }, 0)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { boxOffice_received }) => {
                      return acc + +parseFloat(boxOffice_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { total_revenue }) => {
                      return acc + +parseFloat(total_revenue);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0) /
                      Records.reduce((acc, { admissions }) => {
                        return acc + +parseFloat(admissions);
                      }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { boxOffice_received }) => {
                      return acc + +parseFloat(boxOffice_received);
                    }, 0) /
                      Records.reduce((acc, { admissions }) => {
                        return acc + +parseFloat(admissions);
                      }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0) /
                      Records.reduce((acc, { boxOffice_received }) => {
                        return acc + +parseFloat(boxOffice_received);
                      }, 0)) *
                      100
                  ) || 0
                }}%
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="swc-report-table"
          border="1"
          v-if="selectedType.id == 'monthwise'"
        >
          <thead class="bg-lightblue font-weight-bold">
            <tr class="bg-lightgrey">
              <td>Date</td>
              <td colspan="14">{{ moment(fromDate).format(" MMM YYYY") }}</td>
            </tr>
            <tr class="blueBg">
              <td>Location</td>
              <td colspan="3">Admission</td>
              <td colspan="3">Concession Revenue</td>
              <td colspan="3">Box Office Revenue</td>
              <td colspan="3">Total Revenue</td>
              <td>SPH</td>
              <td>ATP</td>
            </tr>
            <tr class="blueBg">
              <td></td>
              <td>Budget</td>
              <td>Actuals</td>
              <td>%</td>
              <td>Budget</td>
              <td>Actuals</td>
              <td>%</td>
              <td>Budget</td>
              <td>Actuals</td>
              <td>%</td>
              <td>Budget</td>
              <td>Actuals</td>
              <td>%</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody v-if="Records.length == 0">
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-if="Records.length">
            <tr
              v-for="(dayWiseObj, dayWiseIndex) in Records"
              :key="dayWiseIndex"
            >
              <td class="blueBg text-left">{{ dayWiseObj.cinema_name }}</td>
              <!-- admissions -->
              <td class="text-right">{{ dayWiseObj.budget_admissions }}</td>
              <td class="text-right">{{ dayWiseObj.admissions }}</td>
              <td class="text-right">
                {{ dayWiseObj.budget_per_admissions }}%
              </td>
              <!-- admissions -->
              <!-- concession -->
              <td class="text-right">
                {{ currFormat(dayWiseObj.budget_concessions_received) }}
              </td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.concessions_received) }}
              </td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.budget_per_concessions_received) }}%
              </td>
              <!-- concession -->
              <!-- box office -->
              <td class="text-right">
                {{ currFormat(dayWiseObj.budget_boxOffice_received) }}
              </td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.boxOffice_received) }}
              </td>
              <td class="text-right">
                {{ currFormat(dayWiseObj.budget_per_boxOffice_received) }}%
              </td>
              <!-- box office -->
              <!-- total revenue -->
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.budget_total_revenue) }}
              </td>
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.total_revenue) }}
              </td>
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.budget_per_total_revenue) }}%
              </td>
              <!-- total revenue -->
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.sph) }}
              </td>
              <td class="blueBg text-right">
                {{ currFormat(dayWiseObj.atp) }}
              </td>
            </tr>
            <tr class="blueBg font-weight-bold">
              <td class="text-left">Total</td>
              <!-- admissions -->
              <td class="text-right">
                {{
                  Records.reduce((acc, { budget_admissions }) => {
                    return acc + +parseFloat(budget_admissions);
                  }, 0)
                }}
              </td>
              <td class="text-right">
                {{
                  Records.reduce((acc, { admissions }) => {
                    return acc + +parseFloat(admissions);
                  }, 0)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (Records.reduce((acc, { admissions }) => {
                      return acc + +parseFloat(admissions);
                    }, 0) /
                      Records.reduce((acc, { budget_admissions }) => {
                        return acc + +parseFloat(budget_admissions);
                      }, 0)) *
                      100
                  )
                }}%
              </td>
              <!-- admissions -->

              <!-- concession -->
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { budget_concessions_received }) => {
                      return acc + +parseFloat(budget_concessions_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0) /
                      Records.reduce((acc, { budget_concessions_received }) => {
                        return acc + +parseFloat(budget_concessions_received);
                      }, 0)) *
                      100
                  )
                }}%
              </td>
              <!-- concession -->

              <!-- box office -->
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { budget_boxOffice_received }) => {
                      return acc + +parseFloat(budget_boxOffice_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { boxOffice_received }) => {
                      return acc + +parseFloat(boxOffice_received);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (Records.reduce((acc, { boxOffice_received }) => {
                      return acc + +parseFloat(boxOffice_received);
                    }, 0) /
                      Records.reduce((acc, { budget_boxOffice_received }) => {
                        return acc + +parseFloat(budget_boxOffice_received);
                      }, 0)) *
                      100
                  )
                }}%
              </td>
              <!-- box office -->

              <!-- total revenue -->
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { budget_total_revenue }) => {
                      return acc + +parseFloat(budget_total_revenue);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { total_revenue }) => {
                      return acc + +parseFloat(total_revenue);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (Records.reduce((acc, { total_revenue }) => {
                      return acc + +parseFloat(total_revenue);
                    }, 0) /
                      Records.reduce((acc, { budget_total_revenue }) => {
                        return acc + +parseFloat(budget_total_revenue);
                      }, 0)) *
                      100
                  )
                }}%
              </td>
              <!-- total revenue -->

              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { concessions_received }) => {
                      return acc + +parseFloat(concessions_received);
                    }, 0) /
                      Records.reduce((acc, { admissions }) => {
                        return acc + +parseFloat(admissions);
                      }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    Records.reduce((acc, { boxOffice_received }) => {
                      return acc + +parseFloat(boxOffice_received);
                    }, 0) /
                      Records.reduce((acc, { admissions }) => {
                        return acc + +parseFloat(admissions);
                      }, 0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: {
            cine_id: "",
            cine_name: "",
          },
          selectedCinemaName: "",
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        typeArr: [
          { id: "daywise", name: "Day Wise" },
          { id: "monthwise", name: "Month Wise" },
        ],
        selectedType: { id: "daywise", name: "Day Wise" },
        monthArr: [
          { id: "01", name: "01(Jan)" },
          { id: "02", name: "02(Feb)" },
          { id: "03", name: "03(Mar)" },
          { id: "04", name: "04(Apr)" },
          { id: "05", name: "05(May)" },
          { id: "06", name: "06(Jun)" },
          { id: "07", name: "07(Jul)" },
          { id: "08", name: "08(Aug)" },
          { id: "09", name: "09(Sep)" },
          { id: "10", name: "10(Oct)" },
          { id: "11", name: "11(Nov)" },
          { id: "12", name: "12(Dec)" },
        ],
        selectedMonth: "",
        yearArr: [],
        selectedYear: "",
        Records: [],
        excelFilePath: "",
        grandTotal: {},
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      this.setYearArr();

      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
    },
    mounted() {},
    methods: {
      moment,
      emptyData() {
        this.Records = [];
      },
      setYearArr() {
        let currentYear = new Date().getFullYear() - 20;
        for (let i = 1; i <= 20; i++) {
          this.yearArr.push({
            id: i,
            name: currentYear + i,
          });
        }
        this.yearArr.reverse();
        this.selectedMonth = this.monthArr.filter((z) => {
          return z.id == moment().format("MM");
        }).length
          ? this.monthArr.filter((z) => {
              return z.id == moment().format("MM");
            })[0]
          : "";

        this.selectedYear = this.yearArr.filter((z) => {
          console.log(z);
          return String(z.name) == moment().format("YYYY");
        }).length
          ? this.yearArr.filter((z) => {
              return String(z.name) == moment().format("YYYY");
            })[0]
          : "";
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // let cinemas = [
              //   {
              //     cine_id: "all",
              //     cine_name: "All Cinemas",
              //   },
              // ];
              // if (data.Records.length == 1) {
              //   cinemas = [];
              // }
              this.dropDown.cinemas = [ ...data.Records];
              this.CinemasCopy = [ ...data.Records];
              // this.dropDown.cinemas = [...data.Records];
              // this.CinemasCopy = [...data.Records];
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getBudgetReport(isExcel = "N") {
        if (isExcel == "N") {
          this.Records = [];
        }
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }

        if (this.selectedType.id == "monthwise") {
          if (!this.selectedMonth) {
            return this.$toasted.show("Please Select Month");
          }
          if (!this.selectedYear) {
            return this.$toasted.show("Please Select Year");
          }
        }
        let loader = this.$loading.show();
        if (this.selectedType.id == "monthwise") {
          this.fromDate = `${this.selectedYear.name}-${this.selectedMonth.id}-01`;
          this.toDate = `${this.selectedYear.name}-${this.selectedMonth.id}-01`;
        } else {
          (this.fromDate = moment(this.fromDate).format("YYYY-MM-DD")),
            (this.toDate = moment(this.toDate).format("YYYY-MM-DD"));
        }
        let payload = {
          dayType: this.selectedType.id,
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: this.fromDate,
          toDate: this.toDate,
          excel: isExcel,
        };
        ReportsService.getMonthDayWiseTracker(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length) {
              this.Records = [...data.Records];
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
            }
            this.$toasted.show(data.message);
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
  .blueBg {
    background-color: #75a7f0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/monthDayWiseTracker.vue